<template>
  <div>
    <Header/>

    <StatusMessage
      :status="snackbarStatus.active"
      :color="snackbarStatus.color"
      :message="snackbarStatus.message"
    />

    <main>
      <transition
        appear
        name="component-fade"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
    </main>

    <Footer/>
  </div>
</template>

<style>
main {
  min-height: 400px;
}
</style>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import StatusMessage from '@/components/lib/StatusMessage'
import './assets/css/style.css'

export default {
  name: 'App',

  components: {
    Header,
    Footer,
    StatusMessage
  },

  computed: {
    ...mapGetters(['snackbarStatus'])
  }
}
</script>
